import { Modal, Table, Typography } from "antd";
import React from "react";

const FinalAssessmentPage = ({ isModalOpen, onCancel, data, loading }) => {
  const columns = [
    {
      title: "Студент",
      dataIndex: "student",
      key: "student",
      sorter: (a, b) => a.student.localeCompare(b.student),
      width: 250,
      fixed: true,
      render: (student) => (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {student}
        </Typography.Title>
      ),
    },
    {
      title: "Итоговая оценка",
      dataIndex: "finalAssessment",
      key: "finalAssessment",
      render: (assessment) => (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {assessment}
        </Typography.Title>
      ),
    },
  ];
  return (
    <Modal
      title={"Оценки за семестр"}
      visible={isModalOpen}
      onCancel={onCancel}
      footer={null}
      bodyStyle={{ minHeight: 800, paddingTop: 0 }}
    >
      <Table
        columns={columns}
        dataSource={data}
        bordered
        pagination={{ position: ["topLeft"], pageSize: 15 }}
        size={"small"}
        loading={loading}
      />
    </Modal>
  );
};

export default FinalAssessmentPage;
